import { Trash2, Undo2, PauseCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { round2 } from "@/lib/format";
import { Empty } from "@/components/ui-kit";

export default function HeldDialog({ open, onClose, held, onRecall, onDelete }) {
  const { t, money } = useApp();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="held-dialog">
        <DialogTitle className="font-heading text-2xl flex items-center gap-2"><PauseCircle className="w-6 h-6" />{t("held_sales")}</DialogTitle>
        {held.length === 0 ? <Empty icon={PauseCircle} text={t("no_held")} testid="held-empty" /> : held.map((h) => (
          <div key={h.id} className="rounded-xl border border-border p-3 flex items-center gap-3" data-testid="held-row">
            <div className="flex-1 min-w-0">
              <div className="font-bold truncate">{h.label || `#${h.id.slice(0, 4).toUpperCase()}`}</div>
              <div className="text-sm text-muted-foreground" dir="ltr">{new Date(h.at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })} · {h.cart.length} · {money(round2(h.cart.reduce((s, l) => s + l.price * l.qty, 0)))}</div>
            </div>
            <button type="button" onClick={() => onRecall(h)} className="h-14 px-5 rounded-xl bg-[#0B2A5B] text-white font-bold flex items-center gap-2" data-testid="held-recall-btn"><Undo2 className="w-5 h-5" />{t("recall")}</button>
            <button type="button" onClick={() => onDelete(h.id)} className="h-14 w-14 rounded-xl bg-destructive/10 text-destructive grid place-items-center" aria-label={t("clear")} data-testid="held-delete-btn"><Trash2 className="w-5 h-5" /></button>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
}
